import React, { useState, useEffect } from "react";
import { COLORS } from "../../Constants/AppColors.js";
import { useTranslation } from "react-i18next";
import "../../Translation/i18n";
import i18n from "i18next";
// import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import Aos from "aos";
import "aos/dist/aos.css";
import Modal from "react-bootstrap/Modal";
import APIs from "../../network/APIs.js";
import "./style.css";

function CouponsPage() {
  const { t } = useTranslation();

  const [innerWidthState, setInnerWidthState] = useState(window.innerWidth);
  const [innerHeightState, setInnerHeightState] = useState(window.innerHeight);
  const [directionState, setDirectionState] = useState("ltr");
  const [show, setShow] = useState(false);

  const [requestResponseState, setRequestResponseState] = useState([]);
  const [selectedIndexState, setSelectedIndexState] = useState(-1);
  // var selectedIndex = -1;



  React.useEffect(() => {
    Aos.init();

    const getCoupons = () => {
      console.log("getCoupons() Started");
      if (requestResponseState.length === 0)
        APIs.instance.getCoupons().then(([statusCode, data]) => {
          if (statusCode === 200) {
            setRequestResponseState(data.results);
          }
        });
    };
  
    getCoupons();
  
    const getIssues = () => {
      console.log("getIssues() Started");
      if (requestResponseState.length === 0)
        APIs.instance.getIssues().then(([statusCode, data]) => {
          if (statusCode === 200) {
            setRequestResponseState(data.results);
          }
        });
    };
  
    getIssues();

    if (i18n.language.includes("en")) {
      setDirectionState("ltr");
    } else {
      setDirectionState("rtl");
    }

    function handleResize() {
      console.log("resized to: ", window.innerWidth, "x", window.innerHeight);
      setInnerWidthState(window.innerWidth);
      setInnerHeightState(window.innerHeight);
    }

    window.addEventListener("resize", handleResize);

    console.log("i18n.locale: " + i18n.language);
  }, []);

  var issueDetailsItems = null;

  // eslint-disable-next-line no-lone-blocks
  {
    selectedIndexState >= 0
      ? (issueDetailsItems = requestResponseState[
          selectedIndexState
        ].tranches.map((item, index) => (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <label
              style={{
                color: "#049FDB",
                marginTop: 10,
                fontSize: 17,
                textAlign: "center",
                fontFamily: i18n.language.includes("en")
                  ? "CI-Font-Body-Text"
                  : "CI-Font-Body-Text-ar",
              }}
            >
              {i18n.language.includes("en") ? item.name_en : item.name_en}
            </label>
            <label
              style={{
                color: "#898D90",
                marginTop: -2,
                fontSize: 14,
                textAlign: "center",

                fontFamily: i18n.language.includes("en")
                  ? "CI-Font-Body-Text"
                  : "CI-Font-Body-Text-ar",
              }}
            >
              {i18n.language.includes("en")
                ? item.description_en
                : item.description_ar}
            </label>{" "}
          </div>
        )))
      : (issueDetailsItems = null);
  }

  const listItems = requestResponseState.map((item, index) => (
    <div
      data-aos="fade-zoom-out"
      data-aos-offset="100"
      class="col-11 col-md-6 col-lg-4 mx-0 mb-4 scrollbar scrollbar-lady-lips force-overflow"
    >
      <div
        class="card p-0 overflow-hidden h-100 shadow "
        style={{ borderRadius: 20 }}
      >
        <img
          src={require("../../assets/bg_header_item.png")}
          class="card-img-top img-fluid mx-auto d-block"
          style={{ height: 170 }}
          alt=""
        />
        <div
          class="card-body "
          style={{
            backgroundColor: "#EAEEF6",
          }}
        >
          <label
            style={{
              color: "#0047BA",
              marginTop: -10,
              fontSize: 20,
              marginBottom: 5,
              textAlign: i18n.language.includes("en") ? "left" : "right",
              width: "100%",
              fontFamily: i18n.language.includes("en")
                ? "CI-Font-Subtitle"
                : "CI-Font-Subtitle-ar",
            }}
          >
            {/* {t("issue") + (index + 1)} */}
            {i18n.language.includes("en") ? item.name_en : item.name_ar}
          </label>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              // backgroundColor: "#000",
              // height: "55%",
              justifyContent: i18n.language.includes("en") ? "left" : "right",
              // marginTop: 10,
              width: "100%",
              marginBottom: 20,
            }}
          >
            <label
              style={{
                color: "#049FDB",
                textAlign: i18n.language.includes("en") ? "left" : "right",
                fontSize: 14,
                whiteSpace: "pre-wrap",
                fontFamily: i18n.language.includes("en")
                  ? "CI-Font-Body-Text"
                  : "CI-Font-Body-Text-ar",
              }}
            >
              {i18n.language.includes("en")
                ? item.description_en
                : item.description_ar}
            </label>
          </div>

          {i18n.language.includes("en") ? (
            <button
              style={{
                borderColor: "#ffffff01",
                alignItems: "center",
                justifyContent: i18n.language.includes("en") ? "left" : "right",
              }}
              onClick={() => {
                setSelectedIndexState(index);
                setShow(true);
              }}
              class="shape"
            >
              <text
                style={{
                  position: "relative",
                  fontFamily: i18n.language.includes("en")
                    ? "CI-Font-Body-Text"
                    : "CI-Font-Body-Text-ar",
                  fontSize: 13,
                  marginLeft: i18n.language.includes("en") ? -30 : 0,
                  marginRight: i18n.language.includes("ar") ? -30 : 0,
                  top: "-2.5px",
                }}
              >
                {t("read_more")}
              </text>
              {/* <img
              src={
                i18n.language.includes("en")
                  ? require("../../assets/left_read_more_btn.svg").default
                  : require("../../assets/right_read_more_btn.svg").default
              }
              style={{
                position: "absolute",
                bottom: i18n.language.includes("en") ? 15 : 15,
                left: i18n.language.includes("en") ? 10 : null,
                right: i18n.language.includes("ar") ? 10 : null,
              }}
              width="100"
              height="25"
              alt=""
            /> */}
            </button>
          ) : (
            <button
              style={{
                borderColor: "#ffffff01",
                alignItems: "center",
                justifyContent: i18n.language.includes("en") ? "left" : "right",
              }}
              onClick={() => {
                setSelectedIndexState(index);
                setShow(true);
              }}
              class="shape_ar"
            >
              <text
                style={{
                  position: "relative",
                  fontFamily: i18n.language.includes("en")
                    ? "CI-Font-Body-Text"
                    : "CI-Font-Body-Text-ar",
                  fontSize: 13,
                  marginLeft: i18n.language.includes("en") ? -30 : 0,
                  marginRight: i18n.language.includes("ar") ? -30 : 0,
                  top: "-2.5px",
                }}
              >
                {t("read_more")}
              </text>
              {/* <img
              src={
                i18n.language.includes("en")
                  ? require("../../assets/left_read_more_btn.svg").default
                  : require("../../assets/right_read_more_btn.svg").default
              }
              style={{
                position: "absolute",
                bottom: i18n.language.includes("en") ? 15 : 15,
                left: i18n.language.includes("en") ? 10 : null,
                right: i18n.language.includes("ar") ? 10 : null,
              }}
              width="100"
              height="25"
              alt=""
            /> */}
            </button>
          )}
        </div>
      </div>
    </div>
  ));

  return (
    <div
      dir={directionState}
      style={{
        backgroundColor: "#F7F8F9",
        backgroundSize: "cover",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        
        <label
          style={{
            color: COLORS.PageTitleFirstColor,
            marginTop: 20,
            marginBottom: -20,
            fontSize: 35,
            textAlign: i18n.language.includes("en") ? "left" : "right",
            fontFamily: i18n.language.includes("en")
              ? "CI-Font-Title"
              : "CI-Font-Title-ar",
          }}
        >
          {t("coupons_pt1")}{" "}
          <label
            style={{
              color: COLORS.PageTitleFirstColor,
              marginTop: 20,
              marginBottom: -20,
              fontSize: 35,
              textAlign: i18n.language.includes("en") ? "left" : "right",
              fontFamily: i18n.language.includes("en")
                ? "CI-Font-Title"
                : "CI-Font-Title-ar",
            }}
          >
            {t("coupons_pt2")}{" "}
          </label>
        </label>
        <section className="py-4 py-lg-5 container">
          <div className="row">{listItems}</div>
        </section>
      </div>
      {selectedIndexState >= 0 ? (
        <Modal
          show={show}
          onHide={() => setShow(false)}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          centered
          scrollable
        >
          <Modal.Header closeButton>
            <Modal.Title
              style={{
                color: "#0047BA",
                width: "100%",
                textAlign: "center",
                marginTop: 10,
                fontSize: 25,
                fontFamily: i18n.language.includes("en")
                  ? "CI-Font-Subtitle"
                  : "CI-Font-Subtitle-ar",
              }}
              id="example-custom-modal-styling-title"
            >
              {/* {t("issue") + (selectedIndexState + 1)} */}
              {i18n.language.includes("en")
                ? requestResponseState[selectedIndexState].name_en
                : requestResponseState[selectedIndexState].name_ar}
            </Modal.Title>
          </Modal.Header>
          <Modal.Header>
            <Modal.Title
              style={{
                color: "#049FDB",
                marginTop: 10,
                fontSize: 17,
                textAlign: "center",
                fontFamily: i18n.language.includes("en")
                  ? "CI-Font-Body-Text"
                  : "CI-Font-Body-Text-ar",
              }}
              id="example-custom-modal-styling-title"
            >
              {i18n.language.includes("en")
                ? requestResponseState[selectedIndexState].description_en
                : requestResponseState[selectedIndexState].description_ar}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {issueDetailsItems}
            </div>
          </Modal.Body>
          <Modal.Header>
            <Modal.Title
              style={{
                color: "#049FDB",
                marginTop: 10,
                fontSize: 16,
                textAlign: "center",
                width: "100%",
                fontFamily: i18n.language.includes("en")
                  ? "CI-Font-Subtitle"
                  : "CI-Font-Title-ar",
              }}
              id="example-custom-modal-styling-title"
            >
              {t("Through_Misr_for_Central_clearing")}
            </Modal.Title>
          </Modal.Header>
        </Modal>
      ) : null}
    </div>
  );
}

export default CouponsPage;
